document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[data-product-media-slider]');
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const track = slider.querySelector('[data-product-media-track]');
    const slides = Array.from(slider.querySelectorAll('[data-product-media-slide]'));
    const dotsWrapper = slider.querySelector('[data-product-media-dots]');
    const dots = dotsWrapper ? Array.from(dotsWrapper.querySelectorAll('[data-product-media-dot]')) : [];

    if (!track || slides.length <= 1) return;

    let currentIndex = 0;
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    const threshold = 40; // px swipe før vi bytter bilde

    function updateSlider(index) {
      if (index < 0) index = 0;
      if (index > slides.length - 1) index = slides.length - 1;
      currentIndex = index;
      const offset = -index * 100;
      track.style.transform = `translateX(${offset}%)`;

      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }

    // Dots-klikk
    if (dots.length) {
      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const idx = Number(dot.dataset.productMediaDot || 0);
          updateSlider(idx);
        });
      });
    }

    // Touch events (mobil)
    slider.addEventListener('touchstart', (e) => {
      if (!e.touches || !e.touches.length) return;
      startX = e.touches[0].clientX;
      currentX = startX;
      isDragging = true;
    }, { passive: true });

    slider.addEventListener('touchmove', (e) => {
      if (!isDragging || !e.touches || !e.touches.length) return;
      currentX = e.touches[0].clientX;
    }, { passive: true });

    slider.addEventListener('touchend', () => {
      if (!isDragging) return;
      const diff = currentX - startX;

      if (Math.abs(diff) > threshold) {
        if (diff < 0 && currentIndex < slides.length - 1) {
          updateSlider(currentIndex + 1);
        } else if (diff > 0 && currentIndex > 0) {
          updateSlider(currentIndex - 1);
        }
      }

      isDragging = false;
      startX = 0;
      currentX = 0;
    });

    // (Valgfritt) Mouse drag for desktop
    let mouseDown = false;
    let mouseStartX = 0;
    let mouseCurrentX = 0;

    slider.addEventListener('mousedown', (e) => {
      mouseDown = true;
      mouseStartX = e.clientX;
      mouseCurrentX = mouseStartX;
    });

    window.addEventListener('mousemove', (e) => {
      if (!mouseDown) return;
      mouseCurrentX = e.clientX;
    });

    window.addEventListener('mouseup', () => {
      if (!mouseDown) return;
      const diff = mouseCurrentX - mouseStartX;
      if (Math.abs(diff) > threshold) {
        if (diff < 0 && currentIndex < slides.length - 1) {
          updateSlider(currentIndex + 1);
        } else if (diff > 0 && currentIndex > 0) {
          updateSlider(currentIndex - 1);
        }
      }
      mouseDown = false;
      mouseStartX = 0;
      mouseCurrentX = 0;
    });

    // Startposisjon
    updateSlider(0);
  });
});
